import { useState } from 'react';

interface Props {
  elements: string[];
}

/**
 * "Import Log" popover — lists a phone-image/conversation resource's unsupportedElements
 * (Angular resource.html ~770, uib-popover-html). Self-contained click-to-toggle popover
 * opening upward from the footer; a transparent backdrop closes it (works inline and in the
 * detached window, unlike a document-level listener).
 */
export default function ImportLogButton({ elements }: Props) {
  const [open, setOpen] = useState(false);
  if (!elements || elements.length === 0) return null;

  return (
    <span style={{ position: 'relative', display: 'inline-block', marginLeft: 4 }}>
      <button type="button" className="btn btn-default" onClick={() => setOpen((o) => !o)} data-testid="viewer-import-log-btn">
        Import Log
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 1050 }} />
          <div
            className="popover right"
            data-testid="viewer-import-log-panel"
            style={{
              display: 'block',
              position: 'absolute',
              // Angular popover-placement="right-bottom": to the right of the button, bottom
              // edges aligned (so it extends upward, away from the viewport bottom). Clear
              // Bootstrap's base `.popover { top: 0 }` so `bottom` alone drives the vertical.
              top: 'auto',
              bottom: 0,
              left: '100%',
              marginLeft: 10,
              zIndex: 1060,
              minWidth: 260,
              maxWidth: 420,
            }}
          >
            {/* Left-pointing arrow (Bootstrap .popover.right .arrow), moved from the default
                vertical center down to the button's center (~17px up from the aligned bottom). */}
            <div className="arrow" style={{ top: 'auto', bottom: 6, marginTop: 0 }} />
            <h3 className="popover-title">Unsupported Elements</h3>
            <div className="popover-content" style={{ maxHeight: 300, overflowY: 'auto' }}>
              {elements.map((el, i) => (
                <div key={i}>
                  <i className="fas fa-code" /> <small>{el}</small>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </span>
  );
}
